import { url } from "@jeehoon/utils";

export const HEADER_MENU = [
  {
    title: "Home",
    link: url.home,
  },
  {
    title: "Portfolio",
    link: url.portfolio,
  },
  {
    title: "Resume",
    link: url.resume,
  },
  {
    title: "Blog",
    link: url.blog,
  },
  {
    title: "Lab",
    link: url.lab,
  },
];